import { render, staticRenderFns } from "./SettingsAuthTosRequired.vue?vue&type=template&id=61f74bda&"
import script from "./SettingsAuthTosRequired.vue?vue&type=script&lang=ts&"
export * from "./SettingsAuthTosRequired.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports